module.exports = __webpack_public_path__ + "static/media/0x.f8dbea54.png";